import api from "../../api/api";

/**
 * Ambil data activities dari endpoint /activities dengan pagination
 * @param {number} page - Nomor halaman (default 1)
 * @param {number} size - Jumlah data per halaman (default 10)
 * @returns {Promise<Object>} - Response berisi { data, meta, links }
 */
const getActivities = async (page = 1, size = 10) => {
  try {
    const response = await api.get(`/activities?page=${page}&size=${size}`);

    // Laravel Resource + Pagination biasanya punya struktur:
    // { data: [...], meta: {...}, links: {...} }
    return {
      data: response.data.data || [],
      meta: response.data.meta || {},
      links: response.data.links || {},
    };
  } catch (error) {
    console.error("Error fetching activities:", error);
    // Kembalikan struktur kosong agar tidak error di frontend
    return {
      data: [],
      meta: { current_page: 1, per_page: size, total: 0, last_page: 1 },
      links: {},
    };
  }
};

/**
 * Ambil detail activity berdasarkan slug
 * @param {string} slug - Slug unik dari activity
 * @returns {Promise<Object|null>} - Detail data activity atau null jika gagal
 */
const getActivityBySlug = async (slug) => {
  try {
    // Sesuaikan endpoint API Laravel kamu:
    // Bisa /activities/{slug} atau /activities/show/{slug}
    const response = await api.get(`/activities/${slug}`);

    // Laravel biasanya mengembalikan { data: {...} }
    return response.data.data || response.data || null;
  } catch (error) {
    console.error(`Error fetching activity with slug "${slug}":`, error);
    return null;
  }
};

// Default export
const activityService = {
  getActivities,
  getActivityBySlug,
};

export default activityService;
